import { Box, CircularProgress } from "@mui/material"
import React from "react"
import { customPalette } from "../../../../theme"
import { DefaultTypography } from "../../../components/typography/default-typography"

type IProps = {
  icon: React.JSX.Element
  count: number
  isReady?: boolean
}

export function ModuleCount({ icon, count, isReady = true }: IProps): React.JSX.Element {
  function getBProjectCardStatus(): React.JSX.Element {
    return (
      <Box
        display="flex"
        alignItems="center"
        gap={1}
        sx={{ background: customPalette.lightBlue5, height: "30px", px: 1, py: 2, borderRadius: 3 }}>
        {icon}
        <Box px={1} borderRadius={2} sx={{ background: customPalette.lightBlue1 }}>
          {isReady ? (
            <DefaultTypography
              label={count.toString() ?? "0"}
              fontSize="14px"
              fontWeight={400}
              color={customPalette.lightBlue5}
            />
          ) : (
            <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
              <CircularProgress size={16} />
            </Box>
          )}
        </Box>
      </Box>
    )
  }

  return getBProjectCardStatus()
}
